import { Pipe, PipeTransform } from '@angular/core';
import { Checklist } from "../../classes/checklist";

@Pipe({
  name: 'checklistFilter',
  pure: false
})
export class ChecklistFilterPipe implements PipeTransform {

  transform(checklistList: Array<Checklist>, filterValue: string): any {
    if (!checklistList || !filterValue) {
      return checklistList;
    }
    return checklistList.filter((checklist: Checklist) => {
      return checklist.name.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 ||
          checklist.description.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
    });
  }

}
